import { Stack } from "@fluentui/react";
import React from "react";
import { useViewport } from "../../../../styles";
import { ShimmerCircle } from "../../../Shimmer/ShimmerCircle/ShimmerCircle";
import { ShimmerLine } from "../../../Shimmer/ShimmerLine/ShimmerLine";
import { isExtraLargeOrBiggerViewport, isSmallToLargeViewport } from "../../LeftNav";
import { personaWrapperStyles, profileContainerStyles } from "../LeftNavProfile/LeftNavProfile.styles";
import { LeftNavProfileShimmerInternalProps } from "./LeftNavProfileShimmer.types";

export const LeftNavProfileShimmer: React.FC<LeftNavProfileShimmerInternalProps> = ({
    isNavCollapsed
}) => {
    const viewport = useViewport();
    let circleShimmerSize = 48;
    const smallCircleSize = 28;
    if (isSmallToLargeViewport(viewport)) {
        circleShimmerSize = smallCircleSize;
    }

    return (
        <Stack horizontal={true} styles={profileContainerStyles(viewport)}>
            <Stack styles={personaWrapperStyles(isNavCollapsed)}>
                <ShimmerCircle height={circleShimmerSize} />
            </Stack>
            {
                isNavCollapsed ? undefined : (
                    <Stack verticalAlign="center" tokens={{childrenGap: 16}}>
                        <ShimmerLine width={171} height={8} />
                        {isExtraLargeOrBiggerViewport(viewport) && <ShimmerLine width={150} height={8} />}
                    </Stack>
                )
            }
        </Stack>
    );
};
